import { Pipe, PipeTransform } from '@angular/core';
import { DayOfWeek, getWeekName } from '../../enums';

@Pipe({
  name: 'weekIdToName',
  standalone: true,
  pure: true,
})
export class WeekIdToNamePipe implements PipeTransform {
  transform(weekId: DayOfWeek): string {
    return getWeekName(weekId);
  }
}
